import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';

import Input from 'components/input/input';
import Select from 'components/select/select';
import DateTimePicker from 'components/date_time_picker/date_time_picker';
import TextEditor from 'components/text_editor/text_editor';

import { treatmentShape } from 'helpers/shared_types';
import { ReactComponent as ArrowRightSVG } from 'icons/arrow-right.svg';

import { REFERRAL_STATUSES, TYPES } from 'config/treatment';

import { optionShape } from 'helpers/shared_types';

const ViewComponent = ({
  onSubmit,
  onSelectChange,
  onDateChange,
  onChange,
  onMachineSettingsEditorChange,
  onNotesEditorChange,
  treatment,
  hasOtherTreatmentType,
  doctorOptions,
  treatingOrgOptions,
  validation,
}) => {
  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header">
          <h2 className="th-canvas-title">
            <Link to="/treatments">Treatments</Link>
            <span>
              <ArrowRightSVG />
            </span>
            Edit
          </h2>
          <section className="view-actions">
            <button className="btn-green" data-cy="submit" onClick={onSubmit}>
              Submit
            </button>
          </section>
        </header>
        <div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">Details</h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column justify-between">
            <div className="w-100 flex flex-column items-start justify-between margin-between">
              <div className="w-100">
                <Select
                  className="treatment-type"
                  valid={validation.type}
                  label="Treatment type*"
                  value={treatment.type}
                  options={TYPES}
                  onChange={(selectedOption) =>
                    onSelectChange('type', selectedOption)
                  }
                />
              </div>
              {hasOtherTreatmentType && (
                <div className="w-100 flex flex-column items-start justify-between margin-between">
                  <div className="w-100">
                    <div className="w-100">
                      <Input
                        name="type"
                        label="Treatment type: Other*"
                        value={treatment.type.value || treatment.type}
                        valid={validation.type}
                        onChange={(event) => onChange(event)}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="w-100 flex flex-row justify-between margin-between">
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-50">
                    <Select
                      className="doctor-select"
                      valid={validation.doctor}
                      label="Doctor*"
                      value={treatment.doctor}
                      options={doctorOptions}
                      onChange={(selectedOption) =>
                        onSelectChange('doctor', selectedOption)
                      }
                    />
                  </div>
                  <div className="w-50">
                    <Select
                      className="treating-org-select"
                      valid={validation.treatingOrg}
                      label="Treating organization"
                      value={treatment.treatingOrg}
                      options={treatingOrgOptions}
                      onChange={(selectedOption) =>
                        onSelectChange('treatingOrg', selectedOption)
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="w-100 flex-row items-start justify-between margin-between">
                <div className="w-100 flex flex-row justify-between margin-between">
                  <div className="w-50">
                    <Select
                      className="referral-status-select"
                      valid={validation.referralStatus}
                      label="Referral status"
                      value={treatment.referralStatus}
                      options={REFERRAL_STATUSES}
                      onChange={(selectedOption) =>
                        onSelectChange('referralStatus', selectedOption)
                      }
                    />
                  </div>
                  <div className="w-50">
                    <DateTimePicker
                      label="Referral date"
                      valid={validation.referredAt}
                      showTimeInput={false}
                      value={treatment.referredAt}
                      onChange={(value) => onDateChange({ value })}
                    />
                  </div>
                </div>
                <div className="w-100 flex flex-row justify-between margin-between">
                  <TextEditor
                    name="Machine Settings"
                    valid={true}
                    value={treatment.machineSettings}
                    label="Machine Settings"
                    onChange={onMachineSettingsEditorChange}
                  />
                </div>
                <div className="w-100 flex flex-row justify-between margin-between">
                  <TextEditor
                    name="Notes"
                    valid={true}
                    value={treatment.notes}
                    label="Notes"
                    onChange={onNotesEditorChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

ViewComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onSelectChange: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  treatment: treatmentShape.isRequired,
  hasOtherTreatmentType: PropTypes.bool,
  doctorOptions: PropTypes.arrayOf(optionShape),
  treatingOrgOptions: PropTypes.arrayOf(optionShape),
  validation: PropTypes.shape({
    doctor: PropTypes.bool.isRequired,
    type: PropTypes.bool.isRequired,
    referralStatus: PropTypes.bool.isRequired,
    treatingOrg: PropTypes.bool.isRequired,
    customer: PropTypes.bool.isRequired,
    referredAt: PropTypes.bool.isRequired,
  }).isRequired,
};

export default ViewComponent;
